<!--图文互动-->
<template>
  <div id="QuillEditor" class="QuillEditor">
    <quill-editor
      class="ql-editor"
      ref="myTextEditor"
      v-model="quillEditors"
      :image-tag-class="'img-size'"
      :options="editorOption"
      @ready="onEditorReady($event)"
    />
    <input
      id="selectfileObj"
      type="file"
      style="display: none"
      @click="
        (e) => {
          e.target.value = '';
        }
      "
      @change="getFilef($event)"
    />
  </div>
</template>

<script>
// import { container } from 'quill-image-extend-module'
// Quill.register('modules/ImageExtend', ImageExtend)
import { quillEditor, Quill } from 'vue-quill-editor';
// Vue.use(VueQuillEditor)
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// import { mapState } from 'vuex'
import { cosUpload } from '@/utils/cosUpload';
import { FileUploadType } from '@/utils/constant';
// import Video from '@/util/quill-video'
import Image from '@/utils/quill-image';
import { Message } from 'element-ui';
// import ImageResize from "quill-image-resize-module"; // 引用
// Quill.register("modules/imageResize", ImageResize); // 注册
// Quill.register(Video, true)
Quill.register(Image, true);
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '截图' },
  { Choice: '.ql-sign', title: '视频节点' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '有序列表' },
  { Choice: '.ql-list[value="bullet"]', title: '无序列表' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '上传图片' },
];

export default {
  name: 'TFQuillEditor',
  components: {
    quillEditor,
  },
  props: {
    quillEditorValue: {
      type: String,
      default: '',
    },
    // 视频上传配置
    uploadVideoConfig: {
      type: Object,
      default() {
        return {
          uploadUrl: '', // 上传地址
          maxSize: 10, // 图片上传大小限制，默认不超过2M
          name: 'Filedata', // 图片上传字段
        };
      },
    },
  },
  data() {
    return {
      quillEditors: '',
      editorOption: {
        placeholder: '请输入笔记内容',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ color: [] }, { background: [] }],
              ['image'],
              ['insertMetric'],
              ['sign'],
            ],
            handlers: {
              insertMetric: () => {
                this.$emit('signCut');
              },
              sign: () => {
                this.$emit('videoNode');
              },
              image: function () {
                // 劫持原来的图片点击按钮事件
                // QuillWatch.emit(this.quill.id)
                document.getElementById('selectfileObj').click();
              },
              video: () => {
                this.videoForm.show = true;
              },
            },
          },
        },
        // 保留空格保留换行, 并自动换行
        whitespace: 'pre-wrap',
      },
      uploader: '',
      accessid: '',
      accesskey: '',
      host: '',
      policyBase64: '',
      signature: '',
      callbackbody: '',
      key: 'uploads/comment/',
      expire: 0,
      g_object_name: 'live',
      g_object_name_type: 'random_name',
      now: Date.parse(new Date()) / 1000,
      timestamp: Date.parse(new Date()) / 1000,
      changefileName: '',
      uploadpathURL: '/uploads/comment',
      // 视频上传变量
      videoForm: {
        show: false, // 显示插入视频链接弹框的标识
        videoLink: '',
        activeName: 'first',
      },
      loading: false,
    };
  },
  computed: {
    // ...mapState({
    //     uid: state => state.user.uid
    // }),
    editor() {
      return this.$refs.myTextEditor.quillEditors;
    },
  },
  watch: {
    quillEditorValue: function () {
      this.quillEditors = this.quillEditorValue;
    },
    quillEditors: function () {
      this.$emit('editorContentChange', this.quillEditors);
    },
  },
  created() {
    this.quillEditors = this.quillEditorValue;
  },
  mounted() {
    this.initButton();
    this.initSign();
    this.initTitle();
  },
  methods: {
    initTitle() {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = '';
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice);
        if (!tip) continue;
        tip.setAttribute('title', item.title);
      }
    },
    initSign() {
      const sourceEditorButton = document.querySelector('.ql-sign');
      sourceEditorButton.innerHTML = '<div class="video-cut"></div>';
    },
    initButton() {
      const sourceEditorButton = document.querySelector('.ql-insertMetric');
      sourceEditorButton.innerHTML = '<div class="video-cut"></div>';
    },
    getMyTextEdit() {
      return this.$refs.myTextEditor.quill;
    },
    onEditorReady(quill) {
      quill.root.addEventListener(
        'paste',
        (e) => {
          console.log('复制');
          let clipboardData = e.clipboardData;
          let i = 0;
          let items, item, types;

          if (clipboardData) {
            items = clipboardData.items;

            if (!items) {
              return;
            }
            item = items[0];
            types = clipboardData.types || [];

            for (; i < types.length; i++) {
              if (types[i] === 'Files') {
                item = items[i];
                break;
              }
            }
            if (item && item.kind === 'file' && item.type.match(/^image\//i)) {
              e.preventDefault();
              let file = item.getAsFile();
              this.updatefile(file);
            }
          }
        },
        false
      );
    },
    getFilef(e) {
      const file = e.target.files[0];
      this.updatefile(file);
    },
    async updatefile(file) {
      const imageExtensions = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'svg',
        'webp',
      ];
      const fileExtension = file.name.toLowerCase().split('.').pop();
      if (!imageExtensions.includes(fileExtension)) {
        return Message.error('只能上传图片文件');
      }
      const { url } = await cosUpload(file, false, FileUploadType.COURSE);
      console.log('[<-- url上传图片返回的url -->]', url);
      let quill = this.$refs.myTextEditor.quill;
      // 如果上传成功返回图片URL
      if (quill && url) {
        console.log('[<-- 进来了富文本编辑器 -->]');
        // 获取光标所在位置
        let length = this.quillEditors ? this.quillEditors.length : 0;
        // 插入图片  res.info为服务器返回的图片地址
        quill.length = length;
        let index = quill.selection.savedRange.index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(index, 'image', {
          url: url,
          style: 'width: 559px;height: 258px;',
        });
        // 调整光标到最后
        // 调整光标到最后
        quill.setSelection(index + 1);
        quill.focus();
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败');
      }
    },
    async updatefiles(file) {
      const { url } = await cosUpload(file, false, FileUploadType.COURSE);
      console.log('[<-- url截图图片返回的url -->]', url);
      let quill = this.$refs.myTextEditor.quill;
      // 如果上传成功返回图片URL
      if (quill && url) {
        // 获取光标所在位置
        let length = this.quillEditors ? this.quillEditors.length : 0;
        console.log('[<-- length -->]', length);
        // 插入图片  res.info为服务器返回的图片地址
        quill.length = length;
        let index = quill.selection.savedRange.index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(index, 'image', {
          url: url,
          style: 'width: 559px;height: 258px;',
        });
        // 调整光标到最后
        // 调整光标到最后
        quill.setSelection(index + 1);
        quill.focus();
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败');
      }
    },
    /** --------- 视频上传相关 start ---------  */
    insertVideoLink(videoLink) {
      if (!videoLink) return this.$message.error('视频地址不能为空！');
      this.videoForm.show = false;
      let quill = this.$refs['myTextEditor'].quill;
      // 获取富文本
      let length = this.quillEditors.length;
      // 获取光标位置：当编辑器中没有输入文本时，这里获取到的 range 为 null
      quill.length = length;
      let index = quill.selection.savedRange.index;
      console.log('index', index);
      // 在光标所在位置 插入视频
      quill.insertEmbed(index, 'video', { url: videoLink });
      // 调整光标到最后
      quill.setSelection(index + 1);
      quill.focus();
    },
    // el-文件上传组件
    async onBeforeUploadVideo(file) {
      this.loading = true;
      let acceptArr = ['video/mp4'];
      const isVideo = acceptArr.includes(file.type);
      // const isLt1M = file.size / 1024 / 1024 < this.uploadVideoConfig.maxSize
      if (!isVideo) {
        this.hideLoading();
        this.$message.error('只能上传mp4格式文件!');
        return;
      }
      const { url } = await cosUpload(file, false, FileUploadType.COURSE);
      if (url) {
        this.onSuccessVideo(url);
      }
      console.log('url', url);
    },
    // 文件上传成功时的钩子
    onSuccessVideo(url) {
      this.hideLoading();
      this.insertVideoLink(url);
    },
    hideLoading() {
      this.loading = false;
    },
    /** --------- 视频上传相关 end --------- */
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ql-formats {
  margin-right: 0px !important;
}
::v-deep .ql-insertMetric {
  background-image: url('../images/note-cut.png') !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 5px;
}
::v-deep .ql-sign {
  background-image: url('../images/note-sign.png') !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  width: 16px !important;
  height: 16px !important;
  margin: 0 5px;
}
</style>
